import { useContext } from 'react';
import { PermissionContext } from 'components/Global/AuthLayout';
import FnfClearanceComponent from 'components/Settings/FnfClearance';

export const FnfClearance = () => {
	const context = useContext(PermissionContext);

	return <div>{context.isSuperAdmin && <FnfClearanceComponent />}</div>;
};
